<div class="app-bookmarks-dialog">
  <div class="header">
    <h3>Add Photos</h3>
    <button mat-icon-button class="close-button" (click)="close()">
      <mat-icon>close</mat-icon>
    </button>
  </div>

  <div class="content">
    <div class="charger-form">
      <div class="error-message" *ngIf="state() === 'error'">
        <mat-icon>error</mat-icon>
        Something went wrong. Please try again later.
      </div>

      <div class="success-message" *ngIf="state() === 'success'">
        <mat-icon>check_circle</mat-icon>
        Successfully added the photos.
      </div>

      <!-- Photos -->
      <div class="photo-upload">
        <div style="margin-bottom: 10px">
          <div style="font-weight:500">Add photos</div>
          <div style="margin-top:5px;color:#888;font-size:.9rem;">
            Add helpful photos like storefronts, notices, or signs (optional)
          </div>
          <div style="margin-top:12px;color:#333;font-size:.9rem;display: flex;align-items: center;gap: 8px;">
            <div class="avatar">
              <span>{{ user()?.displayName?.charAt(0) }}</span>
              <app-gc-image [src]="getUserPhoto?.(user().uid)" alt="" />
            </div>
            {{ user()?.displayName }}
          </div>
        </div>

        <div *ngIf="imagePreviews.length === 0">
          <button mat-stroked-button color="primary" (click)="fileInput.click()" type="button">
            <mat-icon>add_a_photo</mat-icon>
            Add photos
          </button>
        </div>

        <input
          type="file"
          #fileInput
          multiple
          accept="image/*"
          hidden
          (change)="onFilesSelected($event)"
        />

        <div class="previews" *ngIf="imagePreviews.length > 0">
          <button mat-stroked-button color="primary" (click)="fileInput.click()" type="button" class="add-photos-button">
            <mat-icon>add_a_photo</mat-icon>
          </button>
          <div class="images">
            <ng-container *ngFor="let img of imagePreviews">
              <div class="image-item">
                <img [src]="img" alt="Preview" class="preview-image" />
                <button mat-icon-button class="remove-image-button" (click)="removeImage(img)" type="button">
                  <mat-icon>close</mat-icon>
                </button>
              </div>
            </ng-container>
          </div>
        </div>
      </div>

      <div class="actions">
        <button mat-button type="button" (click)="close()">Cancel</button>
        <button mat-flat-button color="primary" type="submit" [disabled]="state() === 'loading' || images.length === 0" (click)="submitForm()">
          <mat-spinner *ngIf="state() === 'loading'" diameter="20"></mat-spinner>
          Submit
        </button>
      </div>
    </div>
  </div>
</div>
